import { wait } from "@testing-library/user-event/dist/utils";
import MQTT from "precompiled-mqtt";
import { createContext, useContext, useEffect, useRef, useState } from "react";


const WebSocketContext = createContext()


export const WebSocketProvider = ({ children }) => {
    const [connectionStatus, setConnectStatus] = useState("Not connected");
    const [client, setClient] = useState(null);
    const subscriptionsRef = useRef({});// Gestisce i callback per ogni topic

    const mqttConnect = (host) => {
        console.log("WS trying to connect to " + host);
        setClient(MQTT.connect(host));
    };

    const mqttMatch = (subscribedTopic, receivedTopic) => {
        const subParts = subscribedTopic.split("/");
        const recvParts = receivedTopic.split("/");

        for (let i = 0; i < subParts.length; i++) {
            if (subParts[i] === "#") return true; // `#` cattura tutto il resto
            if (subParts[i] === "+") continue; // `+` è un wildcard per un singolo livello
            if (subParts[i] !== recvParts[i]) return false;
        }

        return subParts.length === recvParts.length;
    };

    useEffect(() => {
        if (client) {
            client.on("connect", () => {
                setConnectStatus("Connected");
            });

            client.on("message", (topic, message) => {
                try {
                    const payload = {
                        topic,
                        message: JSON.parse(message.toString()),
                        time: Date.now(),
                    };

                    console.log(`📩 Messaggio ricevuto su ${topic}:`, payload);
                    const subs = subscriptionsRef.current;

                    Object.keys(subs).forEach((subscribedTopic) => {
                        if (mqttMatch(subscribedTopic, topic)) {
                            subs[subscribedTopic].forEach((callback) => callback(payload));
                        }
                    });
                } catch (err) {
                    console.error(`⚠️ Errore nel parsing del messaggio su ${topic}:`, err);
                }
            });
        } else {
            mqttConnect(process.env.REACT_APP_WS_URL);
        }
    }, [client]);

    const subscribe = (topic, callback) => {
        if (!subscriptionsRef.current[topic]) {
            subscriptionsRef.current[topic] = [];
        }
        subscriptionsRef.current[topic].push(callback);

        if (client) {
            client.subscribe(topic, (err) => {
                if (!err) console.log(`📡 Subscribed to ${topic}`);
                else console.error(`❌ Error subscribing ${topic}:`, err);
            });
        }
    };

    const unsubscribe = (topic, callback) => {
        if (!subscriptionsRef.current[topic]) return;

        subscriptionsRef.current[topic] = subscriptionsRef.current[topic].filter(
            cb => cb !== callback
        );

        if (subscriptionsRef.current[topic].length === 0) {
            delete subscriptionsRef.current[topic];
            if (client) client.unsubscribe(topic, () => {
                console.log(`❎ Unsubscribed from ${topic}`);
            });
        }
    };

    return (
        <WebSocketContext.Provider value={{ connectionStatus, client, subscribe, unsubscribe }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    const webSocketContext = useContext(WebSocketContext)
    const { connectionStatus, client, subscribe, unsubscribe } = webSocketContext
    return { connectionStatus, client, subscribe, unsubscribe }
}